module.exports = __webpack_public_path__ + "img/notice.08022dd1.png";